module.exports = __webpack_public_path__ + "static/media/ciencias-medicas-salud.fbe399d6.jpg";